export default __webpack_public_path__ + "static/media/unsupportedIcon.d0b5f843.svg";